import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

export interface NavItem {
  label: string;
  icon: string;
  route: string;
  active?: boolean;
  disabled?: boolean;
  children?: NavItem[];
}

export interface LogoConfig {
  icon: string;
  title?: string;
}

export interface SidebarConfig {
  navItems: NavItem[];
  logo?: LogoConfig;
  width?: number;
}

@Component({
  selector: 's-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    MatDividerModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() config: SidebarConfig = { navItems: [] };
  
  @Output() navItemClick = new EventEmitter<NavItem>();

  onNavItemClick(item: NavItem) {
    // Update active state
    this.config.navItems.forEach(navItem => navItem.active = false);
    item.active = true;
    
    this.navItemClick.emit(item);
  }
} 